<template>
	<div class="school-class-page">
		<!-- 左侧 树形菜单 -->
		<div class="left-tree">
			<el-tree :data="treeData" :default-expand-all="false" :expand-on-click-node="false" node-key="id" ref="tree"
				highlight-current @node-click="handleNodeClick" :props="treeProps" style="width: 100%;" />
		</div>

		<!-- 右侧 内容区域（强制铺满） -->
		<div class="right-content">
			<el-card shadow="hover" v-loading="loading">

				<!-- 未选择年级时 -->
				<div v-if="!currentType" class="empty-tip">
					<i class="el-icon-info"></i>
					<span>请在左侧选择年级</span>
				</div>

				<!-- 选择年级 → 班级列表表格 -->
				<div v-else-if="currentType === 'grade'">
					<div class="btn-group">
						<el-button type="primary" @click="handleAddSingleClass">
							添加班级
						</el-button>
						<el-button type="success" @click="handleBatchAddClass">
							批量添加班级
						</el-button>
						<el-button type="success" @click="forStudentList" v-if="currentClassList.length>0">
							导入学生
						</el-button>
					</div>

					<!-- 暂无班级空提示 -->
					<div v-if="currentClassList.length === 0" class="empty-tip">
						<i class="el-icon-document"></i>
						<span>该年级暂无班级，请点击添加</span>
					</div>

					<!-- 班级表格（宽度100%铺满） -->
					<el-table v-else :data="currentClassList" border style="width: 100%; margin-top: 12px">
						<el-table-column label="序号" prop="index" align="center">
							<template #default="scope">
								{{ scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column label="班级名称" prop="classAlias" align="center" />
						<el-table-column label="校区" prop="areaName" align="center" />
						<el-table-column label="创建学年" prop="schoolYear" align="center">
							<template #default="scope">
								{{scope.row.schoolYear}}学年
							</template>
						</el-table-column>
						<el-table-column label="状态" align="center">
							<template #default="scope">
								<el-tag :type="getStatusTagType(scope.row.status)" size="small">
									{{ getStatusText(scope.row.status) }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column label="学生数量" align="center" prop="studentCount">

						</el-table-column>

						<el-table-column label="操作" align="center" width="200">
							<template #default="scope">
								<el-button type="text" size="small" @click="handleEditClass(scope.row)">
									修改
								</el-button>
								<el-button type="primary" text size="small" @click="handleEnterClass(scope.row)">
									进入班级
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 进入班级 → 学生列表 -->
				<div v-if="currentType === 'class'">
					<div class="title-box">
						<span class="title-text">{{ currentNode.classAlias }}({{currentNode.areaName}}) - 学生列表</span>
						<div class="student-btn-group">
							<el-button type="primary" size="mini" @click="handleAddSingleStudent">
								新增学生
							</el-button>
							<el-button type="success" size="mini" @click="handleBatchAddStudent">
								批量新增学生
							</el-button>
							<el-button type="success" size="mini" @click="getGenerateByClass">
								导出登陆码
							</el-button>

							<el-button size="mini" @click="currentType = 'grade'">
								返回班级列表
							</el-button>
						</div>
					</div>

					<el-table :data="studentList" border style="width: 100%; margin-top: 10px">
						<el-table-column prop="studentNo" label="学生ID" align="center">
							<template #default="scope">

								{{scope.row.studentNo }}

							</template>
						</el-table-column>
						<el-table-column prop="name" label="学生姓名" align="center" />
						<el-table-column prop="status" label="状态" align="center">
							<template #default="scope">
								<el-tag :type="getStatusTagType(scope.row.status)" size="small">
									{{ getStatusText(scope.row.status) }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template #default="scope">
								<el-button type="text" size="small" @click="handleStudentEdit(scope.row)">编辑</el-button>
								<el-button type="text" size="small" @click="forStudentClass(scope.row)">转班</el-button>
								<el-button type="text" size="small"
									@click="getGenerateByUpdateStudent(scope.row)">更新免登</el-button>
								<el-button type="text" size="small" @click="handleStudentDel(scope.row)"
									style="color: red;">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

			</el-card>
		</div>

		<!-- 单个添加班级弹窗 -->
		<el-dialog title="添加单个班级" :visible.sync="addSingleVisible" width="420px" :append-to-body="true" center
			:loading="dialogLoading" @close="dialogLoading = false">
			<el-select v-model="areaId" placeholder="请选择校区" clearable style="width: 220px">
				<el-option v-for="item in areaList" :key="item.id" :label="item.areaName" :value="item.id" />
			</el-select>
			<div class="dialog-desc">
				确定在【{{ currentNode.gradeName }}】下创建班级？
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addSingleVisible = false">取消</el-button>
				<el-button type="primary" @click="doAddSingleClass(1)">确认创建</el-button>
			</div>
		</el-dialog>

		<!-- 批量添加班级弹窗 -->
		<el-dialog title="批量添加班级" :visible.sync="addBatchVisible" width="420px" :append-to-body="true" center
			:loading="dialogLoading" @close="dialogLoading = false">
			<el-select v-model="areaId" placeholder="请选择校区" clearable style="width: 220px">
				<el-option v-for="item in areaList" :key="item.id" :label="item.areaName" :value="item.id" />
			</el-select>
			<!-- 增加max=20，禁止小数，blur失焦自动修正 -->
			<el-input v-model.number="batchNum" type="number" placeholder="请输入创建数量（1‑20）"
				style="width: 100%;margin-top:10px;" :max="20" @blur="handleBatchNumBlur" />
			<div slot="footer" class="dialog-footer">
				<el-button @click="addBatchVisible = false">取消</el-button>
				<el-button type="primary" @click="doBatchAddClass">确认批量创建</el-button>
			</div>
		</el-dialog>

		<!-- 单个添加学生弹窗 → 支持输入姓名 -->
		<el-dialog :title="studentForm.title" :visible.sync="addStudentSingleVisible" width="420px" center
			:append-to-body="true" :loading="dialogLoading" @close="dialogLoading = false">
			<div style="margin-bottom:15px;">
				<label>学生姓名：</label>
				<el-input v-if="!studentForm.classId" v-model="studentForm.name" placeholder="请输入学生姓名" maxlength="8">
					<span slot="suffix" style="
					    color:#999;
					    font-size:12px;
					    white-space:nowrap;
					    margin-left:6px;
					    display: flex;
					    align-items: center;
					  ">
						<span style="color: #409EFF;">{{ (studentForm.name || '').length }}</span>/8
					</span>
					<template slot="prepend"></template>
				</el-input>
				<el-input v-else v-model="studentForm.name" :disabled="studentForm.classId" placeholder="请输入学生姓名"
					style="width: 100%;" clearable />

			</div>
			<div v-if="studentForm.classId" style="margin-bottom:15px;">
				<label>新班级：</label>
				<el-select v-model="studentForm.newClassId" placeholder="请选择班级" style="width:100%;">
					<el-option v-for="item in currentClassList" :key="item.id" :label="item.label" :value="item.id">

					</el-option>
				</el-select>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="addStudentSingleVisible = false">取消</el-button>
				<el-button type="primary" v-if="studentForm.title=='新增学生'" @click="doAddSingleStudent">确认添加</el-button>
				<el-button type="primary" v-else-if="studentForm.classId!=null" @click="saveOrUpdate">确认转班</el-button>
				<el-button type="primary" v-else @click="saveOrUpdate">确认更新</el-button>
			</div>
		</el-dialog>

		<!-- 按照单个班级批量添加学生弹窗 -->
		<el-dialog title="批量新增学生" :visible.sync="addStudentBatchVisible" width="500px" @close="resetStudentBatch" center
			:append-to-body="true" :loading="dialogLoading">
			<div style="display:flex;gap:10px;justify-content:center;margin-bottom:15px;">
				<el-button type="primary" size="small" @click="downloadStudentTemplate">下载学生模板</el-button>
				<el-button type="success" size="small" @click="selectStudentFile">上传学生文件</el-button>
				<input ref="studentFile" type="file" accept=".xlsx,.xls" style="display:none"
					@change="handleStudentUpload" />
			</div>

			<!-- 预览学生列表 -->
			<div v-if="studentPreviewList.length > 0" style="border:1px solid #eee;padding:10px;border-radius:4px;">
				<div style="margin-bottom:8px;font-weight:bold;">已识别 {{ studentPreviewList.length }} 名学生</div>
				<el-table :data="studentPreviewList" border size="mini" style="width:100%;">
					<el-table-column label="序号" type="index" align="center" width="60" />
					<el-table-column label="学生姓名" prop="name" align="center" />
				</el-table>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="addStudentBatchVisible = false">取消</el-button>
				<el-button type="primary" :disabled="studentPreviewList.length===0" @click="doBatchAddStudent">
					确认批量添加
				</el-button>
			</div>
		</el-dialog>

		<!-- 修改班级名称 -->
		<el-dialog title="修改班级名称" :visible.sync="viewClassName" width="500px" @close="viewClassName=false" center
			:append-to-body="true" :loading="dialogLoading">
			<div>
				旧名称:<span>{{classArr.orgName}}</span>
			</div>
			<div>
				<el-input v-model="classArr.classAlias" placeholder="请输入新班级名称" maxlength="8">
					<span slot="suffix" style="
			        color:#999;
			        font-size:12px;
			        white-space:nowrap;
			        margin-left:6px;
			        display: flex;
			        align-items: center;
			      ">
						<span style="color: #409EFF;">{{ (classArr.classAlias || '').length }}</span>/8
					</span>
					<template slot="prepend"></template>
				</el-input>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="viewClassName = false">取消</el-button>
				<el-button type="primary" :disabled="classArr.classAlias==''" @click="forClassName">
					修改
				</el-button>
			</div>
		</el-dialog>
		<!-- 按照年级批量添加学生弹窗 -->
		<el-dialog title="年级批量新增学生" :visible.sync="isStudentVi" width="500px" @close="noStudentVi" center
			:append-to-body="true" :loading="dialogLoading">
			<div style="display:flex;gap:10px;justify-content:center;margin-bottom:15px;">
				<el-button type="primary" size="small"
					@click="exportImportTemplate">下载{{currentNode.gradeName}}模板</el-button>
				<el-button type="success" size="small"
					@click="selectGradeStudentFile">上传{{currentNode.gradeName}}学生文件</el-button>
				<input ref="gradestudentFile" type="file" accept=".xlsx,.xls" style="display:none"
					@change="handleGradeStudentUpload" />
			</div>

			<!-- 预览学生列表 -->
			<div v-if="gradePreviewList.filter(v=>v.classId!=-1).length > 0" style="border:1px solid #eee;padding:10px;border-radius:4px;">
				<div style="margin-bottom:8px;font-weight:bold;">已识别 {{ gradePreviewList.filter(v=>v.classId!=-1).length }} 名学生</div>
				<div v-if="netClassList.length!=0" style="margin-bottom:8px;font-weight:bold;"> {{ netClassList.length }}班级不存在</div>
				<el-table :data="gradePreviewList.filter(v=>v.classId!=-1)" border size="mini" style="width:100%;">
					<el-table-column label="序号" type="index" align="center" width="60" />
					<el-table-column label="学生姓名" prop="name" align="center" />
					<el-table-column label="班级" prop="className" align="center" />
				</el-table>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="isStudentVi = false">取消</el-button>
				<el-button type="primary" :disabled="gradePreviewList.filter(v=>v.classId!=-1).length===0" @click="doBatchAddGradeStudent">
					批量新增
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	const XLSX = require('xlsx');

	export default {
		name: "SchoolClass",
		data() {
			return {
				schoolId: localStorage.getItem("orgId"),
				treeData: [],
				treeProps: {
					label: "label",
					children: "children"
				},
				currentNode: {

				},
				areaId: '',
				areaList: [],
				currentType: "",
				viewClassName: false,
				dialogLoading: false,
				classArr: {
					id: '',
					rogName: '',
					classAlias: '',
				},
				currentClassList: [],
				studentList: [],
				loading: false,

				addSingleVisible: false,
				addBatchVisible: false,
				batchNum: 1,

				// 学生弹窗
				addStudentSingleVisible: false,
				addStudentBatchVisible: false,
				studentBatchNum: 1,

				// 学生表单（用于新增）
				studentForm: {
					name: "",
					id: '',
					title: '新增学生',
					classId: null,
					newClassId: null,
				},
				studentPreviewList: [],
				login: null,
				isStudentVi: false, //批量导入学生弹窗
				gradePreviewList: [],
				netClassList:[],//不存在的班级
			};
		},

		created() {
			this.forarea()
			this.getGradeTree();
		},


		methods: {
			noStudentVi() {
				this.gradePreviewList = []
				this.$refs.gradestudentFile && (this.$refs.gradestudentFile.value = '')
				this.isStudentVi = false
			},
			//批量导入学生
			forStudentList() {
				console.log('currentNode', this.currentNode)
				console.log('this.currentClassList', this.currentClassList)
				// return
				this.isStudentVi = true
			},
			async exportImportTemplate() {

				// 调用你已有的 getFileTypeGet 下载模板
				this.API.getFileTypeGet(this.API.fileurl.getStudentImportTemplate, {
					schoolId: localStorage.getItem('orgId'),
					gradeId: this.currentNode.grade,
				}).then(res => {

					let contentDisposition = res.headers['content-disposition'];
					let fileName = `${this.currentNode.gradeName}学生导入模板.xlsx`;

					// 浏览器触发下载
					const blob = new Blob([res.data]);
					const aTag = document.createElement('a');
					aTag.href = URL.createObjectURL(blob);
					aTag.download = fileName;
					document.body.appendChild(aTag);
					aTag.click();
					URL.revokeObjectURL(aTag.href);
					document.body.removeChild(aTag);
				}).catch(err => {
					this.$message.error(err?.msg || '模板下载失败');
				});
			},
			//年级
			selectGradeStudentFile() {
				this.$refs.gradestudentFile.click()
			},
			handleGradeStudentUpload(e) {
				const file = e.target.files[0]
				if (!file) return

				const reader = new FileReader()
				reader.onload = ev => {
					const data = new Uint8Array(ev.target.result)
					const wb = XLSX.read(data, {
						type: 'array'
					})
					const sheet = wb.Sheets[wb.SheetNames[0]]

					// range:2 跳过前2行，从第3行开始解析
					// header 对应 A B C D E 五列
					const json = XLSX.utils.sheet_to_json(sheet, {
						range: 2,
						header: ['xuhao', 'grade', 'className', 'name']
					})

					// range已经跳过前两行，不要再 shift()
					const list = json
						.filter(i => i.name && i.name.trim()) // 学生姓名为空的行过滤掉
						.map(i => ({
							grade: i.grade ? String(i.grade).replace(/\s+/g, '') : '',
							className: i.className ? String(i.className).trim() : '',
							name: i.name.replace(/\s+/g, '') 
						}))

					if (list.length === 0) {
						this.$message.warning('未识别到有效学生姓名')
						return
					}
					let netClassList=[]
					this.gradePreviewList = list?.map((v, i) => {
						v.classId = -1
						if (this.currentClassList?.find(_v=>_v.label==v.className)){
							v.classId=this.currentClassList?.find(_v=>_v.label==v.className).id
						}else{
							netClassList.push({
								className:v.className
							})
						}
						return {
							...v
						}
					})?.sort((a,b)=>a.classId-b.classId)
					this.netClassList=netClassList
					// this.$message.success(`识别到 ${this.gradePreviewList.length} 名学生${netClassList.length==0?'存在'}`)
				}
				reader.readAsArrayBuffer(file)
			},
			async doBatchAddGradeStudent() {
				if (this.gradePreviewList.length === 0) {
					this.$message.warning("请先上传并识别学生文件");
					return;
				}
				this.loading = true;
				let studentList = []

				// return 
				let list=this.gradePreviewList.filter(v=>v.classId!=-1)
				for (let i = 0; i < list.length; i++) {
					studentList.push({
						name: list[i].name,
						classId: list[i].classId,
						schoolId: Number(this.schoolId),
					})
				}
				this.API.post(this.API.school.postStudentImport, studentList).then(res => {
					this.addStudentBatchVisible = false;
					this.$message.success("批量添加成功");
					this.loading = false;
					this.getStudentList();
				}).catch(() => {
					this.loading = false;
					this.$message.error("批量添加失败");
				})
			},
			forStudentClass(row) {
				this.studentForm.classId = row.classId
				this.studentForm.name = row.name
				this.studentForm.id = row.id
				this.studentForm.title = '转班'
				this.studentForm.newClassId = null
				this.addStudentSingleVisible = true
			},
			resetStudent() {
				this.studentForm.classId = null
				this.studentForm.name = ''
				this.studentForm.id = ''
				this.studentForm.title = '新增学生'
				this.studentForm.newClassId = null
			},
			handleBatchNumBlur() {
				let val = Number(this.batchNum);
				if (isNaN(val)) {
					this.batchNum = null;
					return;
				}
				// 取整数，舍弃小数
				val = Math.trunc(val);
				if (val < 1) val = 1;
				if (val > 20) val = 20;
				this.batchNum = val;
			},

			async forarea() {
				try {
					const res = await this.API.get(this.API.school.getSchoolAreaList, {
						pageNum: 1,
						pageSize: 100,
						// areaName: "",
						schoolId: localStorage.getItem('orgId'),
						status: 1
					})
					this.areaList = res.data.data;
				} catch (error) {
					this.areaList = []
				}
			},
			forClassName() {
				this.API.post(this.API.school.postClassName, {
					id: this.classArr.id,
					classAlias: this.classArr.classAlias
				}).then(res => {
					this.currentClassList = this.currentClassList.map((v, i) => {

						if (v.id == this.classArr.id) {
							v.classAlias = this.classArr.classAlias

						}

						return {
							...v
						}
					})
					this.viewClassName = false
				})
			},
			//更新单个学生
			async getGenerateByUpdateStudent(row) {
				try {
					// 调用你封装的 getFileTypeGet（正确下载PDF的方法）
					let res = await this.API.getFileTypeGet(this.API.school.getGenerateByUpdateStudent, {
						userId: row.id
					});

					// ===================== 下载PDF核心逻辑 =====================
					let blob = new Blob([res.data], {
						type: "application/pdf"
					});
					let downloadUrl = URL.createObjectURL(blob);
					// 创建a标签自动下载
					let a = document.createElement("a");
					a.href = downloadUrl;
					let name =
						`${this.currentNode.areaName}${this.currentNode.initGrade}年级${this.currentNode.classAlias}${row.name}`
					a.download = `${name}.pdf`; // 下载文件名
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					URL.revokeObjectURL(downloadUrl);
					this.$message.success("下载成功！");
				} catch (err) {
					this.$message.error("下载失败，请重试！");
					console.error(err);
				}
			},
			//更新班级
			async getGenerateByUpdateClass(row) {
				try {
					// 调用你封装的 getFileTypeGet（正确下载PDF的方法）
					let res = await this.API.getFileTypeGet(this.API.school.getGenerateByUpdateClass, {
						classId: this.currentNode.id
					});

					// ===================== 下载PDF核心逻辑 =====================
					let blob = new Blob([res.data], {
						type: "application/pdf"
					});
					let downloadUrl = URL.createObjectURL(blob);
					// 创建a标签自动下载
					let a = document.createElement("a");
					a.href = downloadUrl;
					let name =
						`${this.currentNode.areaName}${this.currentNode.initGrade}年级${this.currentNode.classAlias}`
					a.download = `${name}.pdf`; // 下载文件名
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					URL.revokeObjectURL(downloadUrl);
					this.$message.success("下载成功！");
				} catch (err) {
					this.$message.error("下载失败，请重试！");
					console.error(err);
				}
			},
			//生成学生登陆二维码
			async getGenerateByClass() {

				try {
					// 调用你封装的 getFileTypeGet（正确下载PDF的方法）
					let res = await this.API.getFileTypeGet(this.API.school.getGenerateByClass, {
						classId: this.currentNode.id // 你后端要的参数：classId
					});

					// ===================== 下载PDF核心逻辑 =====================
					let blob = new Blob([res.data], {
						type: "application/pdf"
					});
					let downloadUrl = URL.createObjectURL(blob);
					// 创建a标签自动下载
					let a = document.createElement("a");
					a.href = downloadUrl;
					let name =
						`${this.currentNode.areaName}${this.currentNode.initGrade}年级${this.currentNode.classAlias}`
					a.download = `${name}.pdf`; // 下载文件名
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					URL.revokeObjectURL(downloadUrl);
					this.$message.success("下载成功！");
				} catch (err) {
					this.$message.error("下载失败，请重试！");
					console.error(err);
				}
			},
			// 加载年级树形数据
			async getGradeTree() {
				const res = await this.API.get(this.API.school.getSchoolGrad, {
					schoolId: this.schoolId
				});
				this.treeData = res.data.data.map(grade => {
					var label = grade.gradeName
					if (grade.classCount != null && grade.classCount != undefined) {
						label = `${label}(${grade.classCount})`
					}

					return {
						id: grade.grade,
						label: label,
						type: "grade",
						...grade
					};
				});
				if (this.treeData.length > 0) {
					this.handleNodeClick(this.treeData[0])
					this.$nextTick(() => {
						this.$refs?.tree?.setCurrentKey(this.treeData[0].id);
					});
				}
			},

			// 左侧树节点点击
			async handleNodeClick(node) {
				this.currentNode = node;

				this.currentType = "grade";
				this.loading = true;

				const res = await this.API.get(this.API.school.getSchoolGradClass, {
					schoolId: this.schoolId,
					gradeId: node.grade
				});

				this.currentClassList = res.data.data || [];
				if (this.currentClassList.length > 0) {
					this.currentClassList = this.currentClassList.map(v => {
						v.label = `${v.classAlias}(${v.areaName})`
						return {
							...v
						}
					})
				}
				this.loading = false;
			},
			
			// 进入班级
			async handleEnterClass(row) {

				this.currentNode = row;
				this.currentType = "class";
				this.studentList = [];
				// 进入班级自动加载学生列表
				await this.getStudentList();
			},

			// 修改班级
			handleEditClass(row) {
				this.classArr = {
					id: row.id,
					orgName: row.classAlias,
					classAlias: ''
				}
				this.viewClassName = true
				// this.$message.info("待开发：修改 " + row.classAlias);

			},
			// 打开单个添加弹窗
			handleAddSingleClass() {
				this.areaId = ''
				this.addSingleVisible = true;
			},
			// 打开批量添加弹窗
			handleBatchAddClass() {
				this.areaId = ''
				this.addBatchVisible = true;
				this.batchNum = 1;
			},
			// 执行单个/批量创建
			doAddSingleClass(num) {
				if (!this.areaId) return this.$message.warning("请选择校区");
				this.loading = true
				this.API.post(this.API.school.postGradeClass, {
					schoolId: Number(this.schoolId),
					gradeId: this.currentNode.id,
					initGrade: this.currentNode.grade,
					num: num || 1,
					areaId: this.areaId
				}).then(res => {
					this.addSingleVisible = false;
					this.addBatchVisible = false;
					this.$message.success("班级创建成功");
					this.refreshClassList();
					//增加处理左边年级列表显示的班级数量
					this.treeData.map(v=>{
						if(v.id==this.currentNode.id){
							v.label=`${v.gradeName}(${Number(v.classCount)+num})`
						}
						return {
							...v
						}
					})
				}).catch(error => {
					this.loading = false
				})
			},
			// 批量创建
			doBatchAddClass() {
				if (!this.batchNum || this.batchNum < 1 || this.batchNum > 20) {
					this.$message.warning("请输入1-20之间的数量");
					return;
				}

				this.doAddSingleClass(this.batchNum);
			},

			// 刷新班级列表
			async refreshClassList() {
				this.loading = true;
				const res = await this.API.get(this.API.school.getSchoolGradClass, {
					schoolId: this.schoolId,
					gradeId: this.currentNode.id
				});
				this.currentClassList = res.data.data || [];
				this.loading = false;
			},

			// 状态文字
			getStatusText(status) {

				switch (status) {
					case 0:
						return "未入学";
					case 1:
						return "在读";
					case 2:
						return "已毕业";
					default:
						return "未知";
				}
			},
			// 状态标签类型
			getStatusTagType(status) {
				switch (status) {
					case 0:
						return "info";
					case 1:
						return "success";
					case 2:
						return "warning";
					default:
						return "";
				}
			},
			// 打开新增学生（重置表单）
			handleAddSingleStudent() {
				this.resetStudent()

				this.addStudentSingleVisible = true;
			},
			// 打开批量新增
			handleBatchAddStudent() {
				this.addStudentBatchVisible = true;
				this.studentBatchNum = 1;
			},
			// 执行单个新增学生（带姓名）
			async doAddSingleStudent() {
				if (!this.studentForm.name || this.studentForm.name.trim() === "") {
					this.$message.warning("请输入学生姓名");
					return;
				}

				const params = {
					schoolId: Number(this.schoolId),
					classId: this.currentNode.id,
					name: this.studentForm.name
				};
				// console.log('params',params)
				this.loading = true;
				try {
					await this.API.post(this.API.school.postStudentAdd, params);
					this.addStudentSingleVisible = false;
					this.$message.success("学生添加成功");
					await this.getStudentList();
				} catch (e) {
					this.$message.error("添加失败");
				} finally {
					this.loading = false;
				}
			},

			// 批量新增学生
			async doBatchAddStudent() {
				if (this.studentPreviewList.length === 0) {
					this.$message.warning("请先上传并识别学生文件");
					return;
				}
				this.loading = true;
				let studentList = []

				// return 
				for (let i = 0; i < this.studentPreviewList.length; i++) {
					studentList.push({
						name: this.studentPreviewList[i].name,
						classId: this.currentNode.id,
						schoolId: Number(this.schoolId),
					})
				}
				this.API.post(this.API.school.postStudentImport, studentList).then(res => {
					this.addStudentBatchVisible = false;
					this.$message.success("批量添加成功");
					this.loading = false;
					this.getStudentList();
				}).catch(() => {
					this.loading = false;
					this.$message.error("批量添加失败");
				})
			},

			// 获取班级学生列表
			async getStudentList() {
				const res = await this.API.get(this.API.school.getStudentList, {
					classId: this.currentNode.id
				});
				this.studentList = res.data.data || [];
			},

			// 编辑学生
			handleStudentEdit(row) {
				this.resetStudent()
				this.studentForm.id = row.id,
					this.studentForm.name = row.name
				this.studentForm.title = "修改学生信息"
				this.addStudentSingleVisible = true;
			},
			async saveOrUpdate() {
				if (this.studentForm.classId != null && this.studentForm.newClassId == null) return this.$message
					.error("请选择新班级");
				if (this.studentForm.classId != null && this.studentForm.newClassId !== null && this.studentForm
					.classId == this.studentForm.newClassId) return this.$message.success("当前班级一致，无需转班");
				if (this.studentForm.newClassId) {
					this.loginOpen('学生转班中...')
				} else {
					this.loginOpen('学生信息修改中...')
				}

				try {
					let res = await this.API.post(this.API.school.postStudentSaveOrUpdate, {
						id: this.studentForm.id,
						name: this.studentForm.name,
						classId: this.studentForm.newClassId
					})

					if (res.data.code == 200) {
						this.addStudentSingleVisible = false
						this.resetStudent()
						await this.getStudentList();
					}

				} catch (e) {

				} finally {
					this.noLogin()
				}
			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			// 删除学生
			async handleStudentDel(row) {
				this.$confirm(`确定删除学生【${row.name}】吗？`, "提示").then(async () => {
					await this.API.delete(`/sys/student/delete/${row.id}`);
					this.$message.success("删除成功");
					await this.getStudentList();
				});
			},
			downloadStudentTemplate() {
				const data = [
					['序号', '学生姓名'],
					[1, '张三'],
					[2, '李四']
				]
				const ws = XLSX.utils.aoa_to_sheet(data)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, '学生')
				XLSX.writeFile(wb, '学生批量导入模板.xlsx')
			},

			//班级
			selectStudentFile() {
				this.$refs.studentFile.click()
			},

			handleStudentUpload(e) {
				const file = e.target.files[0]
				if (!file) return

				const reader = new FileReader()
				reader.onload = ev => {
					const data = new Uint8Array(ev.target.result)
					const wb = XLSX.read(data, {
						type: 'array'
					})
					const sheet = wb.Sheets[wb.SheetNames[0]]
					const json = XLSX.utils.sheet_to_json(sheet, {
						header: ['xuhao', 'name']
					})

					json.shift()
					const list = json
						.filter(i => i.name && i.name.trim())
						.map(i => ({
							name: i.name.replace(/\s+/g, '')
						}))

					if (list.length === 0) {
						this.$message.warning('未识别到有效学生姓名')
						return
					}
					this.studentPreviewList = list
					this.$message.success(`识别到 ${list.length} 名学生`)
				}
				reader.readAsArrayBuffer(file)
			},

			resetStudentBatch() {
				this.studentPreviewList = []
				this.$refs.studentFile && (this.$refs.studentFile.value = '')
			},
		}
	};
</script>

<style scoped>
	.school-class-page {
		width: calc(80vw);
		display: flex;
		gap: 20px;
		height: calc(100vh - 120px);
		/* width: 100%; */
		box-sizing: border-box;
	}

	.left-tree {
		width: 260px;
		flex-shrink: 0;
		background: #fff;
		padding: 10px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
	}

	.right-content {
		flex: 1;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	.btn-group {
		margin-bottom: 15px;
	}

	.empty-tip {
		padding: 60px 0;
		text-align: center;
		color: #909399;
		font-size: 14px;
	}

	.title-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.title-text {
		font-size: 16px;
		font-weight: bold;
	}

	.student-btn-group {
		display: flex;
		gap: 8px;
		align-items: center;
	}

	.dialog-desc {
		padding: 10px 0;
		font-size: 14px;
		color: #666;
	}

	/* 左侧树选中项：蓝色背景 + 白色文字 */
	::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #409eff !important;
		color: #ffffff !important;
	}

	/* 鼠标 hover 时也好看一点 */
	::v-deep .el-tree-node__content:hover {
		background-color: #e6f7ff !important;
	}

	/deep/ .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		height: 100%;
	}

	/* 给输入框留出右侧空间，避免文字遮挡计数 */
	/deep/ .el-input__inner {
		padding-right: 65px;
	}
</style>